// extracted by mini-css-extract-plugin
export default {"content":"TextContent_content_P0aHP","padding":"TextContent_padding_XpMSV","extraPadding":"TextContent_extraPadding_JC8BX"};